import { render, staticRenderFns } from "./time-bar.component.vue?vue&type=template&id=8ed31fd6"
import script from "./time-bar.component.vue?vue&type=script&lang=js"
export * from "./time-bar.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports